export default {
  path: '/aboutUs',
  name: 'aboutUs',
  component: () => import(/* webpackChunkName: "aboutUs" */ './app.vue'),
  children: [
    {
      path: '',
      component: () => import(/* webpackChunkName: "aboutUs" */ './views/index.vue'),
      meta: {
        title: '关于我们',
      },
    },
  ],
};
